import { createContainer } from 'usage-tracker-multi';
import { makeUuid } from 'usage-tracker-core/common/helpers';
import { getPortalAccountId, getPortalInstanceId, getPortalName } from './metadata';
const {
  createTracker
} = createContainer({
  storeUuidOnUrl: false
});
export const usageTracker = createTracker({
  allowUnauthed: true,
  standalone: true,
  trackerType: 'public',
  isExternalHost: true,
  properties: {
    email: null,
    isOwner: null,
    deviceId: makeUuid,
    hubId: getPortalAccountId,
    channelId: getPortalInstanceId,
    channelName: getPortalName
  }
});